// services/childcare/notifications.js
import { api } from "./utils";
import {
  showLoading,
  updateToSuccess,
  updateToError,
  showError,
} from "../../utils/toast";

// Get notifications
export const getNotifications = async (filters = {}) => {
  try {
    const response = await api.get("/childcare/notifications", {
      params: filters,
    });
    return response;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

// Get unread count
export const getUnreadCount = async () => {
  try {
    const response = await api.get("/childcare/notifications/unread-count");
    return response;
  } catch (error) {
    console.error("Error fetching unread count:", error);
    throw error;
  }
};

// Mark as read - WITH TOAST
export const markAsRead = async (id) => {
  try {
    const response = await api.put(`/childcare/notifications/${id}/read`);
    return response;
  } catch (error) {
    console.error("Error marking as read:", error);
    showError("Failed to mark notification as read");
    throw error;
  }
};

// Mark all as read - WITH TOAST
export const markAllAsRead = async () => {
  const toastId = showLoading("Marking all as read...");
  try {
    const response = await api.put("/childcare/notifications/read-all");
    updateToSuccess(toastId, "All notifications marked as read");
    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to mark all as read";
    updateToError(toastId, errorMessage);
    throw error;
  }
};

// Delete notification - WITH TOAST
export const deleteNotification = async (id) => {
  const toastId = showLoading("Deleting notification...");
  try {
    const response = await api.delete(`/childcare/notifications/${id}`);
    updateToSuccess(toastId, "Notification deleted successfully");
    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete notification";
    updateToError(toastId, errorMessage);
    throw error;
  }
};

// Send notification
export const sendNotification = async (notificationData) => {
  const toastId = showLoading("Sending notification...");
  try {
    const response = await api.post(
      "/childcare/notifications/send",
      notificationData,
    );
    updateToSuccess(
      toastId,
      response.data?.message || "Notification sent successfully!",
    );
    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to send notification";
    updateToError(toastId, errorMessage);
    throw error;
  }
};

// Get notification settings
export const getNotificationSettings = async () => {
  try {
    const response = await api.get("/childcare/notification-settings");
    return response;
  } catch (error) {
    console.error("Error fetching notification settings:", error);
    throw error;
  }
};

// Update notification settings - WITH TOAST
export const updateNotificationSettings = async (settings) => {
  const toastId = showLoading("Updating settings...");
  try {
    const response = await api.put(
      "/childcare/notification-settings",
      settings,
    );
    updateToSuccess(
      toastId,
      response.data?.message || "Settings updated successfully!",
    );
    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to update settings";
    updateToError(toastId, errorMessage);
    throw error;
  }
};
